import firebase from 'firebase/app';

export const SaveSearchLastFive = (company, newUser, id) => {

  var newDoc =firebase
            .firestore()
            .collection('organizations')
            .doc(company)
            .collection('searchedContactLastFive')
            .doc(id)
            .collection('searchedContact')
            .doc()

  newDoc.set({
          contactImg: '',
          contactFirstName: 'Elon',
          contactLastName: 'Musk',     
          contactName: 'Elon Musk',
          contactCompany: 'Tesla',
          contactRole: 'CEO',
          contactEducation: 'MIT',
          contactFieldOfStudy: 'Electric cars, Rockets',
          contactHeadline: 'I change the world with Rockets, Cars, and Doge',
          contactCity: 'Austin',
          contactLinkdinUrl: '',
          contactInterest: ['Rockets', 'Space', 'Cars'],
          contactContent: '',
          contactArticles: '',
          message: '',
          createdBy: newUser.email,
          authorID: id,
          authorFirstName: newUser.firstName,
          authorLastName: newUser.lastName,
          authorCompany: company,
          createdAt: new Date(),
          docId: newDoc.id
      }).then(() =>{
        firebase
          .firestore()
          .collection('organizations')
          .doc(company)
          .collection('prospects')
          .doc(newDoc.id)
          .set({
            CreatedBy: newUser.email,
            Company: company,
            Linkedin: '',
            ProspectName: 'Elon Musk',
            ProspectCompany: 'Tesla',
            ProspectRole: 'CEO',
            ProspectInterest: ['Rockets', 'Space', 'Cars'],
            ProspectContent: '',
            contactImg: '',
            contactEducation: 'MIT',
            contactFieldOfStudy: 'Electric cars, Rockets',
            contactHeadline: 'I change the world with Rockets, Cars, and Doge',
            contactCity: 'Austin',
            createdAt: new Date(),
            AuthorID: id,
            AuthorFirstName: newUser.firstName,
            AuthorLastName: newUser.lastName,
            MessageApproved: 'No',
            MessageSent: 'No',
            InterestPreAi: '',
            CreatedfromApp: "Yes",
            CreatedfromCext: "No",
          })
      }
    )
}
  
export const checkForVProps = (company) =>{
  
    var newDoc = firebase
                .firestore()
                .collection('organizations')
                .doc(company)
                .collection('valueProps')
                .doc('onboarding')
  
                newDoc.get()
                .then((docSnapshot) => {
                  if (docSnapshot.exists) {
                    console.log('document has value props')
                  } else {
                    newDoc.set({
                      Pain: `It's tough to write effective sales messaging. Outbound teams struggle to write personalized messaging that's concise and engaging quickly, so they settle for templates that 99% of prospects ignore.`,
                      Title: `Bound - Generic`,
                      ValueProp: `Bound writes engaging and personalized outreach in just seconds. With better messaging generated by AI, Bound helps your team book more meetings, in less time, automatically.`
                    })
                  }
                })
  
}
